import axios from 'axios';
import * as httpClient from './http-client';
import { getCachedData, setCachedData, CACHE_TTL } from '../helpers/serverCache';

export default {
  async obtenerAplicacion(customHostname) {
    const hostname = httpClient.processHostname(customHostname);
    const cacheKey = hostname === 'localhost' ? 'marca-blanca-web.development' : hostname;
    const cached = getCachedData(`app_auth_${cacheKey}`);
    if (cached) {
      console.log(`🎯 Cache HIT para aplicación: ${hostname}`);
      return cached;
    }
    
    console.log(`📡 Cache MISS - Llamando API para aplicación: ${hostname}`);
    const config = {
      headers: {
        'Content-type': 'application/json',
      },
    };
    const res = await axios.get(
      `${process.env.RAZZLE_API_APLICACIONES}/auth/${cacheKey}`,
      config
    );
    
    setCachedData(`app_auth_${cacheKey}`, res.data, CACHE_TTL.application);
    
    return res.data;
  },
  async getHeader(customHostname, token) {
    const hostname = customHostname
      ? httpClient.processHostname(customHostname)
      : httpClient.getHostname();

    try {
      const res = await httpClient.getWithToken(
        `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/agencia/obtener-header?dominio=${hostname}`,
        token
      );
      return res.data;
    } catch (err) {
      console.error(err);
    }
  },
  async getNavBar(token) {
    const hostname = httpClient.getHostname();
    const res = await httpClient.getWithToken(
      `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/agencia/obtener-solapas?dominio=${hostname}`,
      token
    );
    return res.data;
  },
  async getFooter(token) {
    const hostname = httpClient.getHostname();
    const res = await httpClient.getWithToken(
      `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/agencia/obtener-footer?dominio=${hostname}`,
      token
    );
    return res.data;
  },
  async getOffices(applicationId, token) {
    return httpClient
      .getWithToken(
        `${process.env.RAZZLE_API_APLICACIONES}/aplicaciones-sucursales/aplicacion?aplicacionId=${applicationId}`,
        token
      )
      .then((res) => res.data);
  },
  async getAccionesAplicacion(applicationId, token) {
    return httpClient
      .getWithToken(
        `${process.env.RAZZLE_API_APLICACIONES}/acciones-aplicacion?aplicacionId=${applicationId}`,
        token
      )
      .then((res) => res.data);
  },
};
